import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { Logger } from "./logger.service";
const log = new Logger("RouterState");

@Injectable({
  providedIn: 'root'
})
export class RouterStateService {

  private history = [];

  constructor(
    private router: Router
  ) {}

  public loadRouting(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({urlAfterRedirects}: NavigationEnd) => {
        if (urlAfterRedirects.indexOf('/error/') > -1) return;        
        this.history = [...this.history, urlAfterRedirects];
        log.debug('loadRouting: add page to history = ' + urlAfterRedirects);
      });
  }

  public clear(){
    log.debug('clear history');
    this.history = [];
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || undefined;
  }
}
